import { render, staticRenderFns } from "./CategoryToc.vue?vue&type=template&id=a28a1ef0&scoped=true"
import script from "./CategoryToc.vue?vue&type=script&lang=js"
export * from "./CategoryToc.vue?vue&type=script&lang=js"
import style0 from "./CategoryToc.vue?vue&type=style&index=0&id=a28a1ef0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a28a1ef0",
  null
  
)

export default component.exports